{
  "DATA_ASSISTANT": {
    "TITLE": "Ассистент данных",
    "NEW_CONVERSATION": "+ Новый",
    "LOADING": "Загрузка...",
    "LOADING_MESSAGES": "Загрузка сообщений...",
    "THINKING": "Думает...",
    "UNTITLED": "Диалог без названия",
    "NO_CONVERSATIONS": "Диалогов пока нет. Нажмите «+ Новый», чтобы начать.",
    "EMPTY_STATE": "Выберите диалог или создайте новый, чтобы начать.",
    "PLACEHOLDER": "Что мне для вас узнать?",
    "SHOW_SQL": "Показать SQL",
    "NO_ROWS": "Строки не найдены.",
    "DELETE": "×",
    "DELETE_CONFIRM": "Удалить диалог",
    "DELETE_CONFIRM_DESCRIPTION": "Вы уверены, что хотите удалить этот диалог? Это действие нельзя отменить.",
    "DELETE_CONFIRM_YES": "Удалить",
    "REPORTS": "Отчёты",
    "SAVE_TO_REPORT": "Сохранить в отчёт",
    "NEW_REPORT": "Новый отчёт",
    "REPORT_NAME": "Название отчёта",
    "NO_REPORTS": "Пока нет сохранённых отчётов",
    "REPORTS_EMPTY_STATE": "Выберите отчёт или создайте новый.",
    "REPORT_SAVED": "Сохранено в отчёт",
    "DELETE_REPORT_CONFIRM": "Удалить отчёт",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "Вы уверены, что хотите удалить этот отчёт? Все сохранённые элементы будут удалены.",
    "DELETE_ITEM_CONFIRM": "Удалить элемент",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "Вы уверены, что хотите удалить этот элемент из отчёта?",
    "EXPORT_CSV": "Экспорт в CSV",
    "REFRESH": "Обновить",
    "QUERY_RUNNING": "Выполнение запроса...",
    "QUERY_FAILED": "Запрос не выполнен",
    "AUTO_REFRESH": "Автообновление",
    "AUTO_REFRESH_NONE": "Вручную",
    "AUTO_REFRESH_30S": "30 секунд",
    "AUTO_REFRESH_1M": "1 минута",
    "AUTO_REFRESH_5M": "5 минут",
    "AUTO_REFRESH_10M": "10 минут",
    "EDIT_MESSAGE": "Редактировать сообщение",
    "RENAME_REPORT": "Переименовать отчёт",
    "RENAME_ITEM": "Переименовать элемент",
    "MOVE_UP": "Переместить вверх",
    "MOVE_DOWN": "Переместить вниз",
    "COLLABORATORS": {
      "BUTTON": "Участники",
      "TITLE": "Участники отчёта",
      "DESCRIPTION": "Выберите, какие агенты и команды могут просматривать этот отчёт.",
      "AGENTS": "Агенты",
      "TEAMS": "Команды",
      "SELECT_AGENTS": "Выбрать агентов",
      "SELECT_TEAMS": "Выбрать команды",
      "SAVE": "Сохранить",
      "SAVED": "Участники обновлены",
      "SAVE_FAILED": "Не удалось обновить участников"
    }
  }
}
